export default {
  engine: 'js',
  automaticTest: true,
  jsEngine: {
    savePath: '/report',
    saveType: 'sdk',
  },
  saveResults: false,
  apiKey: process.env.REACT_APP_OOKLA_API_KEY,
  sdkBaseUrl: process.env.REACT_APP_SPEED_TEST_BASE_URL,
  backendApiKey: process.env.REACT_APP_BACKEND_API_KEY,
}
